// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
/* rtl:begin:ignore */
button.carousel-arrow-module__button___j01iA.carousel-arrow-module__important___jhtK1:focus {
  outline: var(--green300, #2b8000) solid 2px;
  outline-offset: 3px;
}
button.carousel-arrow-module__button___j01iA.carousel-arrow-module__important___jhtK1:focus {
  outline-offset: -1px;
}

.carousel-arrow-module__button___j01iA {
  border-radius: 50%;
  width: 60px;
  height: 60px;
  padding: 0;
  border-width: 0;
  background: var(--surface1, #fff);
  box-shadow: 0 2px 12px 0 rgba(32, 32, 32, 0.25);
  font-size: 1.5rem;
  display: block;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.carousel-arrow-module__button--left___eUo8V {
  padding-right: 6px;
  padding-top: 4px;
  left: 0;
}
.carousel-arrow-module__button--right___PUjXJ {
  padding-left: 6px;
  padding-top: 4px;
  right: 0;
}
.carousel-arrow-module__button--right___PUjXJ svg {
  transform: rotate(-180deg);
}
.carousel-arrow-module__button___j01iA svg {
  stroke: var(--neutral75, #424547);
  width: 40px;
  height: 40px;
}

/* rtl:end:ignore */`, "",{"version":3,"sources":["webpack://./node_modules/wa-storybook/styles/tools/functions/_widths.scss","webpack://./client/app/react-components/modal-templates/templates/carousel-modal-comp/carousel-arrow.module.scss","webpack://./node_modules/wa-storybook/styles/tools/mixins/_focus-outline.scss"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACCA,qBAAA;ACMI;EACE,2CAAA;EACA,mBAAA;ADEN;AALE;EACE,oBAAA;AAOJ;;AAHA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,iCAAA;EACA,+CAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;AAMF;AAJE;EACE,kBAAA;EACA,gBAAA;EACA,OAAA;AAMJ;AAHE;EACE,iBAAA;EACA,gBAAA;EACA,QAAA;AAKJ;AAHI;EACE,0BAAA;AAKN;AADE;EACE,iCAAA;EACA,WAAA;EACA,YAAA;AAGJ;;AAAA,mBAAA","sourcesContent":["/** function to get dimensions\n  usage example to get `tablet` value from `$page-max-widths`\n  .class {\n    max-width: dim($page-max-widths, tablet);\n  }\n\n */\n\n@function dim($prop, $key) {\n  @return map-get($prop, $key);\n}\n","@import '~wa-storybook/styles/utils.scss';\n/* rtl:begin:ignore */\n// important class added to increase specificity.\nbutton.button.important {\n  @include focus-outline($color: color(green300));\n\n  &:focus {\n    outline-offset: -1px;\n  }\n}\n\n.button {\n  border-radius: 50%;\n  width: 60px;\n  height: 60px;\n  padding: 0;\n  border-width: 0;\n  background: color(surface1);\n  box-shadow: 0 2px 12px 0 rgba(32, 32, 32, 0.25);\n  font-size: rem(24);\n  display: block;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n\n  &--left {\n    padding-right: 6px;\n    padding-top: 4px;\n    left: 0;\n  }\n\n  &--right {\n    padding-left: 6px;\n    padding-top: 4px;\n    right: 0;\n\n    svg {\n      transform: rotate(-180deg);\n    }\n  }\n\n  svg {\n    stroke: color(neutral75);\n    width: 40px;\n    height: 40px;\n  }\n}\n/* rtl:end:ignore */\n","@import '../functions/color';\n\n@mixin focus-outline($color: color(focus), $applyDirectly: false) {\n  @if $applyDirectly {\n    outline: $color solid 2px;\n    outline-offset: 3px;\n  } @else {\n    &:focus {\n      outline: $color solid 2px;\n      outline-offset: 3px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `carousel-arrow-module__button___j01iA`,
	"important": `carousel-arrow-module__important___jhtK1`,
	"button--left": `carousel-arrow-module__button--left___eUo8V`,
	"button--right": `carousel-arrow-module__button--right___PUjXJ`
};
export default ___CSS_LOADER_EXPORT___;
